import React, { Component,useState,useEffect } from "react";
import Filters from "./scheduleMissedFilter";
import { lighten, makeStyles } from "@material-ui/core/styles";
import { Switch, Route, Link, BrowserRouter } from "react-router-dom";
import Container from "@material-ui/core/Container";
import Table from "@material-ui/core/Table";
import Colors from "./../../Global/colors";
import Grid from "@material-ui/core/Grid";
import TableBody from "@material-ui/core/TableBody";
import List from "@material-ui/core/List";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import InputAdornment from "@material-ui/core/InputAdornment";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Typography from "@material-ui/core/Typography";
import Menu from "@material-ui/core/Menu";
import Popover from "@material-ui/core/Popover";
import swal from "@sweetalert/with-react";
import Checkbox from "@material-ui/core/Checkbox";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { CircularProgress } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import moment from "moment";
import search from "../../Assets/search.png";
import add from "../../Assets/add.png";
import filter from "../../Assets/Filter_Icon.png";
import refresh_token from "./../../Global/refresh_token";
import GlobalApi from "./../../Global";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
// import Tooltip from "@material-ui/core/Tooltip";
import help from '../../Assets/help_icon.png';
import helpAr from '../../Assets/help_icon_ar.png';
import IconButton from "@material-ui/core/IconButton";
import {useTranslation} from 'react-i18next';

//Redux
import { useSelector, useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 650,
  },
  resize: {
    padding: "12px",
    fontSize: "12px",
  },
  visuallyHidden: {
    border: 0,
    clip: " t(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));


function ScheduleMissed() {
  let {t} = useTranslation();
  const classes = useStyles();
  let company = useSelector((state) => state.companyReducer.company);
  let language = useSelector((state) => state.languageReducer.language);

  const [filterMenu1, setFilterMenu1] = React.useState(null);
  const [filterMenu5, setFilterMenu5] = React.useState(null);
  const [selectedAccess, setSelectedAccess] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterApplied, setFilterApplied] = useState(false);
  const [filterDone, setFilterDone] = useState(false);
  const [searchText, setSearchText] = React.useState("");
  const [scheduleLoader, setScheduleLoader] = React.useState(false);
  const [schedule,setSchedule]= React.useState([]);
  const [datesFilters, setDateFilters] = React.useState({
    today: false,
    yesterday: false,
    last7: false,
    last15: false,
    lastMonth: false,
    startFlag:false,
    endFlag:false,
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });

    useEffect(() => {
      fetchMissed(true);
  }, [company?.id]);


  
  const fetchMissed = (reset=false) => {
    setScheduleLoader(true);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: company.id,
      user_id: data.user_id,
      from_d: reset?undefined : datesFilters.startDate,
      to_d: reset ?  undefined : moment(datesFilters.endDate).add(1, 'd').format("YYYY-MM-DD") ,
    };



    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/ScheduleAssignee/get_missed_schedules?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("response======>",response);
        if (response.status === "Success") {
          setScheduleLoader(false);
          let sch = [];
          if(response.data.length == 0){
            setSchedule([]);
            // setState({
            //   Schedule: sch,
            // });
          }else{
            let newData = [...response.data].sort((a, b) => new Date(b.filter_date).getTime() - new Date(a.filter_date).getTime())
              .map((v, i) => {              
                let flag = false;
                v.RescheduleDocs.map((v1, i1) => {
                  if (v1.missed_date === v.filter_date) {
                    flag = true;
                  }
                });
                v["missed"] = flag;
                // let obj = { ...v, filter_date: moment(v.filter_date).format("MMMM DD, YYYY") };

                return(v);
              });

              setSchedule(newData);
          }
            setScheduleLoader(false);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            fetchMissed();
          }
        }
      })
      .catch((error) => console.log(error.message));
  };



  const handleClick3 = (event) => {
    setFilterMenu1(event.currentTarget);
  };




  const handleClick7 = async (event) => {

    setFilterMenu5(event.currentTarget);
  };


  const handleClose3 = () => {
    setFilterMenu1(null);
  };

  const handleClose7 = () => {
    setFilterMenu5(null);
  };


  const handleToday = () => {
    let _datesFilters = {...datesFilters,
    today:!datesFilters.today,
    yesterday: false,
    last7:false,
    last15:false,
    lastMonth:false,
    startFlag:false,
    endFlag:false,
    startDate:moment().format("YYYY-MM-DD"),
    endDate:moment().format("YYYY-MM-DD"),
    }
    setDateFilters(_datesFilters)
  };

  const handleYesterday = () => {
    let _datesFilters = {...datesFilters,
    today: false,
    yesterday:!datesFilters.yesterday,
    last7:false,
    last15:false,
    lastMonth:false,
    startFlag:false,
    endFlag:false,
    startDate:moment().subtract(1,"days").format("YYYY-MM-DD"),
    endDate:moment().subtract(1,"days").format("YYYY-MM-DD"),
    }
    setDateFilters(_datesFilters)
  };


  const handle7Days = () => {
    let _datesFilters = {...datesFilters,
      today: false,
      yesterday: false,
      last7:!datesFilters.last7,
    last15:false,
    lastMonth:false,
    startFlag:false,
    endFlag:false,
    startDate:moment().subtract(7,"days").format("YYYY-MM-DD"),
    endDate:moment().format("YYYY-MM-DD"),
    }
    setDateFilters(_datesFilters)
  };

  const handle1Month = () => {
    let _datesFilters = {...datesFilters,
    today: false,
    yesterday: false,
    last7:false,
    last15:false,
    lastMonth:!datesFilters.lastMonth,
    startFlag:false,
    endFlag:false,
    startDate:moment().subtract(1,"month").format("YYYY-MM-DD"),
    endDate:moment().format("YYYY-MM-DD"),
    }
    setDateFilters(_datesFilters)
  };
  
  

  const handleStartDate = (e) => {
    let _datesFilters = {...datesFilters,
    today: false,
    yesterday: false,
    last7:false,
    last15:false,
    lastMonth:false,
    startFlag:true,
    endFlag:false,
    startDate:e.target.value
    }
    console.log(_datesFilters)
    setDateFilters(_datesFilters)
  };

  const handleEndDate = (e) => {
    let _datesFilters = {...datesFilters,
      today: false,
      yesterday: false,
      last7:false,
      last15:false,
      lastMonth:false,
      startFlag:false,
    endFlag:true,
      endDate:e.target.value
      }
      setDateFilters(_datesFilters)
  };


  const clearDatesFilter = ()=>{
    let _datesFilters = {...datesFilters,
      today: false,
      yesterday: false,
      last7:false,
      last15:false,
      lastMonth:false,
      startFlag:false,
      endFlag:false,
      startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
      }
      setFilterApplied(false)
      setDateFilters(_datesFilters)
      fetchMissed(true)
  }





  const handleDone2 = () => {
    if(datesFilters.today == true || 
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true){
        setFilterApplied(true)
        fetchMissed(false)
      }else{
        setFilterApplied(false)
        fetchMissed(true)
      }
    document.getElementById("schedule3Scroll").scrollTo(0,0);
    setFilterMenu1(null);
    setFilterMenu5(null);

  };



  const open = Boolean(filterMenu1);

  const open5 = Boolean(filterMenu5);


  return (<>
  
  <Grid  container justifyContent="center" alignItems="center" spacing={2} style={{ backgroundColor: "white", padding: "5px 20px",width:'100%', justifyContent:'space-between', borderRadius: "5px", marginTop: "2px"}}>
          <Grid item xs={12} sm={12} md={4}  style={{alignItems:'center', display:'flex'}}>
          <TextField
                size="small"
                autoComplete="off"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={search} width={12} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <Tooltip title={t("Filter Options")}>
                        <img
                          src={filter}
                          width={20}
                          style={{ cursor: "pointer" }}
                          onClick={handleClick3}
                        />
                      </Tooltip>
                    </InputAdornment>
                  ),
                  classes: { input: classes.resize },
                }}
                placeholder={t("Search in existing Schedules")}
                fullWidth
                onChange={(e) => setSearchText(e.target.value)}
                variant="outlined"
                style={{ width: "80%", backgroundColor: Colors.globalColor5 }}
              />
                <Tooltip title={t("Help")}>
            
                <a href="https://www.uraudits.com/knowledge-center/schedules/" target="blank" style={{color:Colors.globalColor8}}>
                <img src={language == "ar" ? helpAr : help} height={25} style={{marginLeft:'5px',marginTop:'5px'}}/>
                  </a>
            
              </Tooltip>


        

            {/* =================================popover 1=========================== */}

            <Popover open={open} anchorEl={filterMenu1} onClose={handleClose3} anchorOrigin={{ vertical: "bottom", horizontal: "center" }} transformOrigin={{ vertical: "top", horizontal: "center" }}>
              <div style={{ width: "150px",  backgroundColor: "white", borderRadius: "5px", padding: "0px" }}>
                <List component="nav" aria-label="secondary mailbox folders">
                  <ListItem button style={{ paddingTop: "2px", paddingBottom: "2px" }} onClick={(e) => handleClick7(e)}>
                    <ListItemText primary={t("Dates")} />
                  </ListItem>
                </List>
              </div>
            </Popover>

            {/* =================================popover 5=========================== */}
            <Popover open={open5} anchorEl={filterMenu5} onClose={handleClose7} anchorOrigin={{ vertical: "center", horizontal: "right" }} transformOrigin={{ vertical: "center", horizontal: "left" }} style={{ margin: "20px" }}>
              <div style={{ width: "300px", minHeight: "100px", backgroundColor: "white", borderRadius: "5px", padding: "10px" }}>
                <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                  {t("Select Date Range")}
                </p>
                <span style={{ display: "block" }}>
                  <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.today} onChange={()=>handleToday()}/>
                  <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                    {t("Today")}
                  </p>
                </span>
                <span style={{ display: "block" }}>
                  <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.yesterday} onChange={()=>handleYesterday()}/>
                  <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                    {t("Yesterday")}
                  </p>
                </span>
                <span style={{ display: "block" }}>
                  <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.last7} onChange={()=>handle7Days()}/>
                  <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                    {t("Last 7 Days")}
                  </p>
                </span>
                {/* <span style={{ display: "block" }}>
                  <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.last15} onChange={()=>handle15Days()} />
                  <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                    Last 15 Days
                  </p>
                </span> */}
                <span style={{ display: "block" }}>
                  <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.lastMonth} onChange={()=>handle1Month()} />
                  <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                    {t("Last Month")}
                  </p>
                </span>
                <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                  {t("Custom Range")}
                </p>
                
                {/* <KeyboardDatePicker className="filterDatePicker" disableToolbar label="From Date"  format="MM/dd/yyyy" margin="normal" id="date-picker-inline" value={datesFilters.startDate} onChange={handleStartDate} KeyboardButtonProps={{ "aria-label": "change date" }} /> */}
                {/* <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 0, width: "100%", marginBottom: 10 }} /> */}
                <form className={classes.container} noValidate>
                <TextField variant="outlined" className="filterDatePicker" label={t("From Date")} type="date" size="small" fullwidth value={datesFilters.startDate} onChange={handleStartDate}  style={{width:'100%', marginTop:'10px'}} InputLabelProps={{ shrink: true }} />
                <TextField variant="outlined" className="filterDatePicker" label={t("To Date")} type="date" size="small" fullwidth value={datesFilters.endDate} onChange={handleEndDate}  style={{width:'100%', marginTop:'10px'}} InputLabelProps={{ shrink: true }} />
                {/* <KeyboardDatePicker className="filterDatePicker" style={{ marginTop: "10px", marginBottom: "10px" }} disableToolbar label="To Date" variant="outlined" format="MM/dd/yyyy" margin="normal" id="date-picker-inline" value={datesFilters.endDate} onChange={handleEndDate} KeyboardButtonProps={{ "aria-label": "change date" }} /> */}
                </form>
                <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 20 }} />
                <Button className="ctBtn" onClick={() => handleDone2()}>
                  {/* onClick={() => onSelectAccess()} */}
                  {t("Done")}
                </Button>
              </div>
            </Popover>
          </Grid>

          <Grid item xs={12} sm={12} md={6} >
             {(filterApplied) && (
              <div
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    backgroundColor: Colors.globalColor9,
                    border: "1px solid #043077",
                    color: "#043077",
                    height: "100%",
                    borderRadius: "5px",
                    display: "inline-flex",
                    alignItems: "center",
                    
                  }}
                >
                  <div
                    style={{
                      display: "inline",
                      borderRight: "1px solid #043077",
                      padding: "5px",
                    }}
                  >
                    {datesFilters.today && "Today"}
                    {datesFilters.yesterday && "Yesterday"}
                    {!datesFilters.today && !datesFilters.yesterday && `From : ${moment(datesFilters.startDate).format('DD-MM-YY')} - To: ${moment(datesFilters.endDate).format("DD-MM-YY")}`}              
                    
                  </div>{" "}
                  <div
                    onClick={() => clearDatesFilter()}
                    style={{
                      display: "inline",
                      padding: "0px 5px",
                      cursor: "pointer",
                    }}
                  >
                    x
                  </div>
                </div>
              </div>
            )}
            </Grid>
        </Grid>
        
    <div style={{height:'64vh',padding:'0px 10px 10px 10px', overflow:'hidden', display:'flex', flexDirection:'column'}}>
    <div  className="scrollbarShow2" id="schedule3Scroll" style={{overflowY:'scroll'}}>

  


    <Filters
            schedule={schedule}
            setSchedule={setSchedule}
            scheduleLoader={scheduleLoader}
            searchText={searchText}
            fetchMissed = {fetchMissed}
          />
    </div>
    </div>
    </>
  )
}

export default ScheduleMissed



